import React from 'react';
import LoadingButton from '@atlaskit/button/loading-button';
import { Field, ErrorMessage } from '@atlaskit/form';
import { Box, xcss } from '@atlaskit/primitives';
import TextArea from '@atlaskit/textarea';
import TextField from '@atlaskit/textfield';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import { fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages';

type Props = {
	submitting: boolean;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	formProps: any;
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	state: any;
	dirty: boolean;
	intl: IntlShape;
};

export const ServicedeskInformationForm = (props: Props) => {
	const {
		submitting,
		formProps,
		state,
		dirty,
		intl: { formatMessage },
	} = props;

	return (
		<form {...formProps} name="informationForm">
			<Field
				name="name"
				defaultValue={state.currName}
				label={formatMessage(messages.name)}
				isRequired
				validate={(value) => (value.length > 2048 ? 'TOO_LONG' : undefined)}
			>
				{({ fieldProps, error }) => (
					<>
						<TextField {...fieldProps} />
						{error && <ErrorMessage>{formatMessage(messages.errorTooBig)}</ErrorMessage>}
					</>
				)}
			</Field>
			<Field
				name="description"
				defaultValue={state.currDesc}
				label={formatMessage(messages.introText)}
				validate={(value) => (value.length > 2048 ? 'TOO_LONG' : undefined)}
			>
				{({ fieldProps, error }) => (
					<>
						<TextArea {...fieldProps} />
						{error && <ErrorMessage>{formatMessage(messages.errorTooBig)}</ErrorMessage>}
						{state.formFailedToSubmit && (
							<ErrorMessage>{formatMessage(messages.errorFailed)}</ErrorMessage>
						)}
					</>
				)}
			</Field>
			<Box xcss={buttonContainerStyles}>
				<LoadingButton
					type="submit"
					isLoading={state.isLoading}
					appearance="primary"
					isDisabled={!dirty || submitting}
					onClick={(event, analyticsEvent) => {
						fireUIAnalytics(analyticsEvent, 'CustomerPortalFormSubmit');
					}}
				>
					{formatMessage(messages.save)}
				</LoadingButton>
			</Box>
		</form>
	);
};

export default injectIntl(ServicedeskInformationForm);

const buttonContainerStyles = xcss({
	paddingTop: 'space.200',
});
